<div class="container">
  <div class="mt-lg-3">
    <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
  </div>
</div>
